<div class="row">
  <div class="col-12 mt-2 savings-plan-search">
    <web-components-asset-search type="savings-plan" (assetSelected)="selectSavingsPlan.emit($event)" />
  </div>
</div>
